export default __webpack_public_path__ + "static/media/arrow_left.9af5c839.svg";